import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';

import { ErrorAlert } from '../components';

export type ErrorStatus = 500 | 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 509 | 510 | 511;
export type ErrorStatusMsg = 'FETCH_ERROR' | 'PARSING_ERROR' | 'TIMEOUT_ERROR' | 'CUSTOM_ERROR';

const getErrorMessage = (status: number | string): string => {
  if (typeof status === 'string') {
    const statusMsg: Record<ErrorStatusMsg, number> = {
      CUSTOM_ERROR: 500,
      PARSING_ERROR: 502,
      FETCH_ERROR: 503,
      TIMEOUT_ERROR: 504,
    };
    status = statusMsg[status as ErrorStatusMsg];
  }

  const { t } = useTranslation(['router']);
  const httpErrors: Record<ErrorStatus, string> = {
    500: t('errors.http.500'),
    501: t('errors.http.501'),
    502: t('errors.http.502'),
    503: t('errors.http.503'),
    504: t('errors.http.504'),
    505: t('errors.http.505'),
    506: t('errors.http.506'),
    507: t('errors.http.507'),
    508: t('errors.http.508'),
    509: t('errors.http.509'),
    510: t('errors.http.510'),
    511: t('errors.http.511'),
  };

  return httpErrors[status as ErrorStatus] || t('errors.general');
};

export const RootBoundary = () => {
  const error = useRouteError() as Response;
  return <ErrorAlert message={getErrorMessage(error?.status)} />;
};
